//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExamenCreate from "./components/ExamenCreate"

export default {
  components: {
    ExamenCreate,
  },
  data() {
    return {
      // Elimina la paginacion
      pagination: {
        page: 1,
        rowsPerPage: 0,
      },

      // Visibilidad de paneles
      showCreate: false,
      showEdit: false,

      columns: [
        { name: "id", label: "Id", field: "id", style: "width: 10px", sortable: true, align: "left" },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          sortable: true,
          align: "left",
          classes: "bg-grey-2 ellipsis",
          style: "width: 50%",
          headerClasses: "bg-primary text-white",
        },
        { name: "activo", label: "Publicado", field: "activo", format: (val) => (val ? "Publicado" : "No publicado") },
        { name: "created_at", label: "Creación", field: "created_at", format: this.momentFromNow },
        { name: "updated_at", label: "Modificación", field: "updated_at", format: this.momentFromNow },
        { name: "actions" },
      ],
      examenes: [],
      selected: [],
    }
  },

  computed: {
    hasSelected() {
      return !!this.selected.length
    },
  },

  mounted() {
    this.loadExamenes()
  },

  methods: {
    async loadExamenes() {
      this.examenes = await this.$store.dispatch("examen/all")
    },
    clickExamen(examen) {
      this.$router.push({ name: "examen", params: { examen: examen.id } })
    },

    // Acciones de ToolBar
    submitExamenCreate(examen) {
      // Agregamos el examen creado a la lista.
      this.examenes.push(examen)

      // Cerramos el panel
      this.showCreate = false

      // Redireccionamos a la edicion del examen.
      this.$router.push({ name: "examen", params: { examen: examen.id } })
    },
    confirmDeleteExamen() {
      this.$q
        .dialog({
          title: "Eliminar examenes",
          message:
            "Por favor, selecciona los examenes que quieres eliminar, para confirmar." +
            " Esta acción no se puede deshacer.",
          cancel: true,
          options: {
            isValid: (val) => val.length > 0,
            type: "checkbox",
            model: [],
            items: this.selected.map((e) => ({ label: e.nombre, value: e.id })),
          },
        })
        .onOk(this.deleteExamen)
    },
    deleteExamen(examenes) {
      console.log("Eliminar", examenes)
    },
    async publish() {
      const promises = this.selected.map((examen) => this.$store.dispatch("examen/publicar", examen.id))

      await Promise.all(promises)

      this.loadExamenes()
    },

    async unpublish() {
      const promises = this.selected.map((examen) => this.$store.dispatch("examen/no_publicar", examen.id))

      await Promise.all(promises)

      this.loadExamenes()
    },
  },
}
